// Dependencies
// -----------------------------------------------
import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

// -----------------------------------------------
// COMPONENT->META -------------------------------
// -----------------------------------------------
class Meta extends React.Component {

  // Constructor
  // ---------------------------------------------
  constructor(props) {
    super(props);
    this.state = {
      review_average: this.props.listing.review_average || 0,
      reviews: (this.props.listing.reviews && this.props.listing.reviews.length) || 0
    };
  }

  // Render
  // ---------------------------------------------
  render() {
    const { listing, brand } = this.props;
    const property = listing.property || {};
    const location = listing.location || {};
    const contact = brand.contact || {};
    const social = (brand.brand_info && brand.brand_info.social) || {};
    const phone = contact.phone || (contact.phone_primary && contact.phone_primary.number) || '';

    return (
      <Helmet>
        <title>{`${property.name || ''} | ${brand.name || ''}`}</title>
        <link rel="canonical" href={`${listing.slug || ''}`} />
        <meta name="description" content={property.summary_description || ''} />
        <meta itemprop="name" content={property.name || ''} />
        <meta itemprop="description" content={property.summary_description || ''} />
        <meta itemprop="image" content="https://example.com/image.jpg" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={social.social_twitter || ''} />
        <meta name="twitter:url" content={`${brand.canonical || ''}/listings/${listing.slug || ''}`} />
        <meta name="twitter:title" content={`${property.name || ''} | ${brand.name || ''}`} />
        <meta name="twitter:description" content={property.summary_description || ''} />
        <meta name="twitter:image" content="https://example.com/image.jpg" />
        {/* Facebook */}
        <meta property="og:image" content="http://example.com/image.jpg" />
        <meta property="og:site_name" content={brand.name || ''} />
        <meta property="og:title" content={`${property.name || ''} | ${brand.name || ''}`} />
        <meta property="og:description" content={property.summary_description || ''} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${brand.canonical || ''}/listings/${listing.slug || ''}`} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:street-address" content={location.adr_street || ''} />
        <meta property="og:locality" content={location.adr_city || ''} />
        <meta property="og:region" content={location.adr_state || ''} />
        <meta property="og:postal-code" content={location.adr_postal_code || ''} />
        <meta property="og:country-name" content={location.adr_country || ''} />
        <meta property="og:email" content={contact.email || ''} />
        <meta property="og:phone_number" content={phone} />
        {/* JSON/LD */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org/",
            "@type": "LodgingBusiness",
            "name": "${property.name || ''}",
            "brand": "${brand.name || ''}",
            "description": "${property.summary_description || ''}",
            ${ this.state.reviews > 0 ? `
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "${this.state.review_average}",
                "ratingCount": "${this.state.reviews}"
              },` : '' }
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "${location.adr_street || ''}",
              "addressLocality": "${location.adr_city || ''}",
              "addressRegion": "${location.adr_state || ''}",
              "postalCode": "${location.adr_postal_code || ''}",
              "addressCountry": "${location.adr_country || ''}"
            }
          }
        `}</script>
      </Helmet>
    );
  }
}

// Map State to Props
// -----------------------------------------------
function mapStateToProps(state) {
  return {
    brand: state.brand ? state.brand : {},
    listing: state.listing ? state.listing : {}
  };
}

// Export
// -----------------------------------------------
export default connect(mapStateToProps)(Meta);